import { Helmet } from "react-helmet-async";

export default function SEO({ title, description }) {
  const t = title ? `${title} | BullionTrack` : "BullionTrack — Live Bullion Rates India";
  const d = description || "Compare real-time gold & silver rates from 13+ dealers across India. Find the lowest bid instantly.";
  return (
    <Helmet>
      <title>{t}</title>
      <meta name="description" content={d} />
      <meta property="og:title" content={t} />
      <meta property="og:description" content={d} />
      <meta property="og:type" content="website" />
    </Helmet>
  );
}
